import { render, staticRenderFns } from "./ExaminDetail.vue?vue&type=template&id=5cb715bc&scoped=true"
import script from "./ExaminDetail.vue?vue&type=script&lang=ts"
export * from "./ExaminDetail.vue?vue&type=script&lang=ts"
import style0 from "./ExaminDetail.vue?vue&type=style&index=0&id=5cb715bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb715bc",
  null
  
)

export default component.exports